import React, { useContext } from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

// redux
import { useSelector } from 'react-redux';
import { getFlatCourseAliases } from 'redux/selectors/course';

// hooks
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { useDuplicateLecture, useHideAddUIOnOpen } from 'lecture_pages/hooks/lecture-page-edit-top-panel';

// components
import TopPanelActionButton from './top-panel-action-button';
import { config } from '@config/config.json';

const DuplicateLecturePageButton = () => {
  const styles = css`
    .duplicate-icon {
      transform: rotate(90deg);
    }
  `;
  const duplicateThisLecture = useDuplicateLecture();
  const params = useLecturePageParams();
  const hideAddUIOnOpen = useHideAddUIOnOpen();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));

  const handleDuplicate = () => {
    hideAddUIOnOpen();
    duplicateThisLecture();
  };

  return (
    <div css={styles}>
      <TopPanelActionButton
        icon='duplicate'
        tooltipText={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.DUPLICATE_LESSON(courseAliases)}
        onClick={handleDuplicate}
        ariaLabel={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.DUPLICATE_LESSON(courseAliases)}
        dataQa={config.pendo.lectureEdit.editMenuTopPanel.duplicateLessonOption}
        className='duplicate-icon'
      />
    </div>
  );
};

export default DuplicateLecturePageButton;
